import { render, staticRenderFns } from "./OhsFooter.vue?vue&type=template&id=4ba30bc8&scoped=true&"
import script from "./OhsFooter.vue?vue&type=script&lang=js&"
export * from "./OhsFooter.vue?vue&type=script&lang=js&"
import style0 from "./OhsFooter.vue?vue&type=style&index=0&id=4ba30bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba30bc8",
  null
  
)

export default component.exports